import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import BottomBox from './BottomBox';
import './grpinv.css'
const GrpInv = () => {
    return ( <Box 

                  sx={theme => ({ [theme.breakpoints.up('sm')]:{marginTop:65,backgroundColor:'rgb(241,241,241)',width:'100vw',maxWidth:'100%',height:'55%'},
                  [theme.breakpoints.between('0','600')]:{marginTop:70,width:'100vw',maxWidth:'100%',backgroundColor:'rgb(241,241,241)'}
                  })}
    
                >
              <Typography>
                  <div className="heading">
                      <p>Our Investors</p>
                  </div>
                  <div className="pplinvest">
                      <div className="img_1">
                            
                            <img  id='ivtpic'src="images/invest/nishad.jpg" alt="" />
                            <div className='ivtnames' >Nishad Hussain</div>
                            <a target='_blank' href="https://www.linkedin.com/in/nishadulla-syed-9a465318/"><img id= 'linkdin' src="images/social-icon/link_inv.png" alt="" /></a>
                      </div>
                      <div className="img_2">
                            
                            <img  id='ivtpic' src="images/invest/praneetha_1.jpg" alt="" />
                            <div className='ivtnames' >Praneetha Ayyagari</div>
                            <a target='_blank' href="https://www.linkedin.com/in/praneetha-ayyagari-3b691913a"><img id= 'linkdin' src="images/social-icon/link_inv.png" alt="" /></a>
                      </div>
                      <div className="img_3">
                            <img   id='ivtpic' src="images/invest/prashanth_1.jpg" alt="" />
                            <div className='ivtnames' >Prashanth Bhatti</div>
                            <a target='_blank' href="https://www.linkedin.com/in/prashanth-bhatti-877102219"><img id= 'linkdin' src="images/social-icon/link_inv.png" alt="" /></a>
                      </div>
                      <div className="img_4">
                            <img  id='ivtpic' src="images/invest/swapnil_1.jpg" alt="" />
                            <div className='ivtnames'>Swapnil Gaike</div>
                            <a target='_blank' href="https://www.linkedin.com/in/swapnilgaike/"><img id= 'linkdin' src="images/social-icon/link_inv.png" alt="" /></a>
                            
                      </div>
                      <div className="img_5">
                            <img  id='ivtpic' src="images/invest/danish.jpg" alt="" />
                            <div className='ivtnames' >Danish Khan</div>
                            <a target='_blank' href="https://www.linkedin.com/in/danish-khan-a96824152/"><img id= 'linkdin' src="images/social-icon/link_inv.png" alt="" /></a>

                      </div>
                      <div className="img_6">
                            
                            <img  target='_blank' id='ivtpic' src="images/invest/mayur.jpeg" alt="" />
                            <div className='ivtnames' >Mayur Thange</div>
                            <a target='_blank' href="https://www.linkedin.com/in/mayur-thange-0127b461/"><img id= 'linkdin' src="images/social-icon/link_inv.png" alt="" /></a>
                      </div>
                      <div className="manymore">
                            <p>And Many More...</p>
                      </div>
                  </div>
              </Typography>
              
    </Box> 
    
);
}
 
export default GrpInv;